const parseOfferData = (offerData) => {
    return {
        partnershipId: offerData?.partnership_id,
        icon: {
            src: offerData?.icon?.url,
            alt: offerData?.icon?.alt,
        },
        title: {
            text: offerData?.name?.text,
            color: offerData?.name?.color,
        },
        heading: {
            text: offerData?.heading?.text,
            color: offerData?.heading?.color,
        },
        subHeading: {
            text: offerData?.sub_heading?.text,
            color: offerData?.sub_heading?.color,
        },
        cta: {
            label: offerData?.cta?.label,
            gaDetails: offerData?.cta?.ga_details,
            action: offerData?.cta?.action?.toLowerCase(),
            url: offerData?.cta?.url?.web,
        },
        tag: {
            text: offerData?.tag?.text,
            color: offerData?.tag?.color,
            bgColor: offerData?.tag?.bg_color,
        },
        isDisabled: offerData?.disabled,
        isExpired: offerData?.is_expired,
    }
}

export const parsePageData = (data) => {
    const parsedData = {
        header: {
            bgImage: data?.header?.bg_image,
            logo: {
                src: data?.header?.logo?.url,
                alt: data?.header?.logo?.alt,
            },
            title: {
                text: data?.header?.title?.text,
                color: data?.header?.title?.color,
            },
            offersClaimed: {
                count: {
                    text: data?.header?.offers_claimed?.count?.offer_count,
                    color: data?.header?.offers_claimed?.count?.color,
                },
                subHeading: {
                    text: data?.header?.offers_claimed?.sub_heading?.text,
                    color: data?.header?.offers_claimed?.sub_heading?.color,
                },
            },
            offersLeft: {
                count: {
                    text: data?.header?.offers_left?.count?.offer_count,
                    color: data?.header?.offers_left?.count?.color,
                },
                subHeading: {
                    text: data?.header?.offers_left?.sub_heading?.text,
                    color: data?.header?.offers_left?.sub_heading?.color,
                },
            },
        },
        onPageLoadGADetails: data?.on_page_load_ga,
        offers: data?.partnership_cards?.map((offerData) => {
            return parseOfferData(offerData)
        }),
    }

    return parsedData
}
